import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { FullScreen } from './elements/global'
import Modal from '../containers/Modal'

import EventLookup from '../containers/EventLookup'
import ManageGuestDetailsFilterButtons from '../containers/ManageGuestDetailsFilterButtons'
import Map from '../containers/Map'
import Pagination from '../containers/Pagination'
import ResultsHeader from '../containers/ResultsHeader'
import ManageGuestDetailsSearchResults from '../containers/ImageMultiFormGrid'

import Type from '../containers/filters/Type'
import Bedrooms from '../containers/filters/Bedrooms'
import Budget from '../containers/filters/Budget'
import AllFilters from '../containers/filters/AllFilters'

function getFilterScreen (screen) {
  switch (screen) {
    case 'type':
      return <Type />
    case 'bedrooms':
      return <Bedrooms />
    case 'budget':
      return <Budget />
    case 'all':
      return <AllFilters />
    default:
      return null
  }
}

export default class ManageDelegateForm extends Component {
  static propTypes = {
    activeFilterScreen: PropTypes.string,
    bootstrapped: PropTypes.bool.isRequired,
    networkError: PropTypes.bool.isRequired,
    downloadAllKeyinstructionsLink: PropTypes.string,
    manageGuestDetailsLink: PropTypes.string
  }

  state = {
    windowWidth: window.innerWidth,
    showMap: false,
  }

  componentDidMount () {
    window.addEventListener('resize', this.resizeListener)
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.resizeListener)
  }

  resizeListener = () => this.setState({ windowWidth: window.innerWidth })

  toggleMap = () => this.setState({ showMap: ! this.state.showMap })

  render () {
    const { activeFilterScreen, bootstrapped, networkError } = this.props

    if (networkError) {
      return (
        <FullScreen>
          <p>Sorry there has been an issue contacting the API. Please refresh your browser and try again.</p>
        </FullScreen>
      )
    }

    if (! bootstrapped) {
      return (
        <FullScreen>
          <p>Please wait, loading...</p>
        </FullScreen>
      )
    }

    const { windowWidth, showMap } = this.state

    const isMobile = windowWidth < 768
    const isDesktop = ! isMobile

    return (
      <>
          <div className='map-listing'>
            {activeFilterScreen && (
              <div className={`search-filter ${activeFilterScreen === 'all' ? 'search-filter--full' : ''}`}>
                <div className='wrapper'>
                  {getFilterScreen(activeFilterScreen)}
                </div>
              </div>
            )}

            {(isDesktop || ! showMap) && (
              <div className='map-listing__manage-guest-details-feed' style={ {paddingTop:'0rem'} }>
                <ResultsHeader isResultForBookingManagement={true}/>
                  <ManageGuestDetailsFilterButtons />

                <ManageGuestDetailsSearchResults isManageBookingSearchResult={true}/>
                <Pagination />
              </div>
            )}
          </div>

          {isMobile && (
            <button className='btn btn--primary btn--icon btn--circle map-listing__switcher' onClick={this.toggleMap}>
              {showMap ? '\uf0ca' : '\uf041'}
            </button>
          )}

        <Modal />
      </>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ManageDelegateForm.js